import React from 'react';
import PropTypes from 'prop-types';

import { Form, Button, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Archived, Draft, Published } from './constants';
import { getTranslatedString } from 'helpers/i18n';

const { confirm } = Modal;

const ActionButtons = ({
  status,
  loading,
  onCreate,
  onArchive,
  onPublish,
  onUpdate,
  onDelete
}) => {
  const form = Form.useFormInstance();

  const handlePublish = () => {
    form.validateFields().then((values) => {
      confirm({
        title: getTranslatedString('landlordPortal.fees.publishFeeTemplateTitle'),
        icon: <ExclamationCircleOutlined />,
        content: getTranslatedString('landlordPortal.fees.publishFeeTemplateDesc'),
        onOk: () => onPublish(values, values.id),
        onCancel: () => false,
        okText: getTranslatedString('landlordPortal.fees.publish'),
        mask: true,
      });
    });
  };

  const handleArchive = () => {
    form.validateFields().then((values) => {
      confirm({
        title: getTranslatedString('landlordPortal.fees.archiveFeeTemplateTitle'),
        icon: <ExclamationCircleOutlined />,
        content: getTranslatedString('landlordPortal.fees.archiveFeeTemplateDesc'),
        onOk: () => onArchive(values, values.id),
        onCancel: () => false,
        okText: getTranslatedString('landlordPortal.fees.archive'),
        mask: true,
        closable: false,
      });
    });
  };

  const handleDelete = () => {
    form.validateFields().then((values) => {
      confirm({
        title: getTranslatedString('landlordPortal.fees.deleteFeeTemplateTitle'),
        icon: <ExclamationCircleOutlined />,
        content: getTranslatedString('landlordPortal.fees.deleteFeeTemplateDesc'),
        onOk: () => onDelete(values, values.id),
        onCancel: () => false,
        okText: getTranslatedString('landlordPortal.fees.delete'),
        mask: true,
        closable: false,
      });
    });
  };

  const handleCreateOrUpdate = () => {
    form.validateFields().then((values) => {
      if (values.id) {
        onUpdate(values, values.id);
      } else {
        onCreate(values)
      }
    });
  };

  return {
    [Draft]: (
      <>
        {form.getFieldValue(['id']) && (
          <Button onClick={handleDelete}>
            {getTranslatedString('landlordPortal.fees.delete')}
          </Button>
        )}
        <Button loading={loading} onClick={handleCreateOrUpdate}>
          {getTranslatedString('landlordPortal.fees.saveAsDraft')}
        </Button>
        <Button onClick={handlePublish}>
          {getTranslatedString('landlordPortal.fees.publish')}
        </Button>
      </>
    ),
    [Published]: (
      <>
        <Button onClick={handleDelete}>
          {getTranslatedString('landlordPortal.fees.delete')}
        </Button>
        <Button onClick={handleArchive}>
          {getTranslatedString('landlordPortal.fees.archive')}
        </Button>
        <Button loading={loading} onClick={handleCreateOrUpdate}>{getTranslatedString('landlordPortal.fees.save')}</Button>
      </>
    ),
    [Archived]: (
      <>
        <Button onClick={handleDelete}>
          {getTranslatedString('landlordPortal.fees.delete')}
        </Button>
        <Button onClick={handlePublish}>
          {getTranslatedString('landlordPortal.fees.publish')}
        </Button>
        <Button loading={loading} onClick={handleCreateOrUpdate}>{getTranslatedString('landlordPortal.fees.save')}</Button>
      </>
    ),
  }[status];
};

ActionButtons.propTypes = {
  status: PropTypes.string.isRequired,
};

ActionButtons.defaultProps = {
  status: Draft,
};

export default ActionButtons;
